<template>
    <div class="container">
        <br>
        <div class="row">
            <div class="col-1">
                <a :href="returnUrl" class="btn btn-sm btn-outline-secondary">{{ "<" }}</a>
            </div>
            <div class="col-11 text-left">
                <p class="main-text">&nbsp;&nbsp;<span class="align-middle" v-html="text.startSimulation"></span></p>
            </div>
        </div>
        <div class="accordion" role="tablist">
            <b-card no-body class="mb-1 text-center">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <a style="cursor:pointer" v-b-toggle.accordion-1>
                        <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />  
                        &nbsp;
                        {{ text.attentionPointIntro }}
                        &nbsp;
                        <font-awesome-icon :icon="['fas', 'caret-down']" />  
                    </a>
                </b-card-header>
                <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text>{{ text.attentionPoints[0] }}</b-card-text>
                        <b-card-text>{{ text.attentionPoints[1] }}</b-card-text>
                        <b-card-text>{{ text.attentionPoints[2] }}</b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
        <br>
        <!--TABS-->
        <navigation slot="tabs"></navigation>
        <br>
        <mentions>
            <span slot="title" v-html="text.understandSimulation"></span>
            <span>
                Les données saisies dans ce simulateur de remboursement ne sont pas enregistrées. Aucune information personnelle n’est demandée.
                <br><br>Toutes les situations ne pouvant être traitées (ex. régimes locaux Alsace Moselle, forfaits et nombres d’actes déjà consommés, etc.), les montants mentionnés ne constituent pas un engagement contractuel sur les remboursements auxquels vous pouvez prétendre au titre de votre contrat santé
                <br><br>Les montants de remboursements simulés ne tiennent pas compte de la possibilité de bénéficier de l’application de la réforme 100% Santé / Reste à Charge 0
                <br><br>Pour plus d’informations sur votre contrat santé, veuillez contacter votre Conseiller Complémentaire Santé
            </span>
        </mentions>
    </div>
</template>

<script>
import resources from '../helpers/resources'
import Branding from '../helpers/branding'

export default {
    data() { return { text : resources } },
    computed: {
        returnUrl() { return Branding.portalUrl() },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue